export default "__VITE_ASSET__5a64086e__"